import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FormDialog, Form, WarningIcon } from "../../../components";
import { appAction } from "@neumetric/blueprint-lib/store";
import { ContinuerActions, isContinuerArchived } from "../../../store";
const Fields = [{ label: "", attribute: "scenario_id", placeholder: "Scenario ID", type: "text", autocomplete: "off" }];
export const ArchiveDeleteDialog = (props) => {
  const { blueprint, isDelete, user } = props;
  const isArchive = isContinuerArchived(blueprint);
  const dispatch = useDispatch();
  const [state, setState] = useState({ formData: { scenario_id: "", email: "" }, error: {} });
  const validateForm = () => {
    let message;
    const { scenario_id } = state.formData;
    if (blueprint.scenario_id !== scenario_id) {
      message = "Invalid Scenario ID";
    }
    if (message) {
      dispatch(appAction.setAlert({ success: false, message: message }));
    }
    return message;
  };
  const handleDelete = async (e) => {
    if (isDelete) {
      let msg = validateForm();
      if (!msg) {
        dispatch(ContinuerActions.setDeleteInProgress(true));
        dispatch(ContinuerActions.deleteBlueprint({ id: blueprint.id }));
      }
    } else if (isArchive) {
      const audits = blueprint.audits;
      let prevAudit = "";
      audits.every((audit) => {
        if (
          audit.audited_changes &&
          Array.isArray(audit.audited_changes.status) &&
          (audit.audited_changes.status[1] === "archived" || audit.audited_changes.status[1] === "archive")
        ) {
          prevAudit = audit.audited_changes.status[0];
        }
        return !Boolean(prevAudit);
      });
      if (prevAudit) {
        dispatch(ContinuerActions.setDeleteInProgress(true));
        dispatch(ContinuerActions.unarchiveBlueprint({ id: blueprint.id, status: prevAudit }));
      }
    } else {
      let msg = validateForm();
      if (!msg) {
        dispatch(ContinuerActions.setDeleteInProgress(true));
        dispatch(ContinuerActions.archiveBlueprint({ id: blueprint.id }));
      }
    }
    props.onClose && props.onClose(true);
  };
  const handleValueChange = (e) => {
    const { error } = state,
      { name, value } = e.target;
    const formData = { ...state.formData };
    formData[name] = value;
    error[name] = "";
    setState((_) => ({ ..._, formData, error: { ...error } }));
  };
  return (
    <FormDialog
      TitleComponent={() => {
        return (
          <div className="row title-sec">
            <WarningIcon className="warning" />
            <h6 className={`f6 exo2 bold`}>{`${
              isDelete ? "Delete" : isArchive ? "Unarchive" : "Archive"
            } Scenario Blueprint ?`}</h6>
          </div>
        );
      }}
      onClose={props.onClose.bind(null, false)}
      className={`create-doc archive-docs ${isDelete ? "delete-docs" : ""}`}
      dialogClassName={`archive-dialog-width`}
      leftBtn={{ label: "Cancel", variant: "lite", color: "#0133CC", onClick: props.onClose.bind(null, false) }}
      rightBtn={{
        label: isDelete ? "Delete" : isArchive ? "Unarchive" : "Archive",
        variant: "lite",
        color: "#FE3333",
        onClick: handleDelete,
        disabled: false,
      }}
    >
      <div className="col content">
        <p className="f9 c000 warn">
          {isDelete ? (
            <React.Fragment>
              This action is <span className="bold">permanent & irreversible.</span>
              <br />
              Type the BlueprintID below to confirm this action.
              <br />
              To stop this action press Cancel
            </React.Fragment>
          ) : (
            <React.Fragment>
              This action will archive this Blueprint.
              <br />
              Type the Blueprint ID below to confirm this action.
              <br />
              To stop this action press Cancel.
            </React.Fragment>
          )}
        </p>
        {(isDelete || (!isDelete && !isArchive)) && (
          <Form
            fieldClass="field-input"
            formData={state.formData}
            error={state.error}
            Fields={Fields}
            onChange={handleValueChange}
          />
        )}
      </div>
    </FormDialog>
  );
};
